@if (loadingStatus()) {
<div class="d-flex align-items-center">
  <svg
    class="ob1-spinner-undetermined"
    viewBox="0 0 50 50"
    style="width: 20px; height: 20px"
    focusable="false"
    aria-hidden="true"
  >
    <circle class="ob1-spinner-undetermined-circle" cx="25" cy="25" r="20"></circle>
  </svg>
  <p class="small visually-hidden m-0" style="visibility: hidden">Chargement en cours...</p>
</div>
} @else {
<div class="d-flex align-items-center">
  <div class="icon {{deviceStatus()?.icone}}" style="font-size: 1rem; line-height: 1.25" aria-hidden="true"></div>
  <div class="small px-1 py-0">{{deviceStatus()?.text}}</div>
</div>
}
